'use client';

import SectionContainer from '@/components/shared/SectionContainer';
import { SafeLink } from '@/components/ui/SafeLink';
import { Box, Button, Flex, Text, Image } from '@skin-seoul/design-system';
import NextImage from 'next/image';
import SectionHeader from '../../components/SectionHeader';
import React from 'react';
import { CLASSNAME, BRAND_CATEGORY_DEFINITIONS } from '@skin-seoul/service';
const BrandCategoriesSection = () => {
  return <SectionContainer containerInnerProps={{
    backgroundColor: 'neutral.50',
    paddingY: {
      base: 12,
      tablet: 12,
      desktop: 16
    },
    gap: 12
  }} data-sentry-element="SectionContainer" data-sentry-component="BrandCategoriesSection" data-sentry-source-file="BrandCategoriesSection.tsx">
      <SectionHeader href="/all-brands/" title={<>
            Discover the Best <Box as="br" display={{
        base: 'none',
        mobile: 'block'
      }} /> in Korean Skincare
          </>} data-sentry-element="SectionHeader" data-sentry-source-file="BrandCategoriesSection.tsx" />
      <Flex direction="column" gap={6} width="100%" data-sentry-element="Flex" data-sentry-source-file="BrandCategoriesSection.tsx">
        {BRAND_CATEGORY_DEFINITIONS.map((category, index) => <Box key={category.type}>
            {index > 0 && <Box borderTop="1px solid" borderColor="neutral.100" mb={6} width="100%" />}
            <Flex alignItems="center" direction={{
          base: 'column',
          desktop: 'row'
        }} gap={{
          base: 4,
          tablet: 5
        }} width="100%">
              <Text color="neutral.500" textStyle="paragraph.small" fontWeight="normal" whiteSpace="nowrap" width={{
            base: '100%',
            desktop: '320px'
          }} minWidth={{
            base: '100%',
            desktop: '320px'
          }} className={CLASSNAME.NOT_TRANSLATE}>
                {category.type}
              </Text>

              <Flex width="100%" overflowX="auto" css={{
            '&::-webkit-scrollbar': {
              display: 'none'
            },
            msOverflowStyle: 'none',
            scrollbarWidth: 'none'
          }}>
                <Flex flex="1" flexWrap={{
              base: 'nowrap',
              desktop: 'nowrap'
            }} justifyContent="flex-start" gap={{
              base: 2,
              tablet: 6
            }}>
                  {category.brandNames.map(brand => <SafeLink unstyled href={brand.url} key={brand.name}>
                      <Box alignItems="center" bg="generic.0" border="1px solid" borderColor="neutral.100" borderRadius="90px" display="flex" height={{
                  base: '96px',
                  tablet: '120px'
                }} justifyContent="center" overflow="hidden" width={{
                  base: '96px',
                  tablet: '120px'
                }} minWidth={{
                  base: '96px',
                  tablet: 'auto'
                }} cursor="pointer" transition="all 0.2s ease-in-out" _hover={{
                  backgroundColor: 'neutral.100/20',
                  borderColor: 'neutral.100',
                  '& > img': {
                    transform: 'scale(1.3)'
                  }
                }} _active={{
                  backgroundColor: 'primary.500/20',
                  borderColor: 'primary.500',
                  '& > img': {
                    transform: 'scale(1.3)'
                  }
                }}>
                        <Image asChild alt={brand.imageAlt} height={{
                    base: '96px',
                    tablet: '120px'
                  }} width={{
                    base: '96px',
                    tablet: '120px'
                  }} transition="transform 0.2s ease-in-out" sizes="(max-width: 767px) 96px, 120px">
                          <NextImage alt={brand.imageAlt ?? ''} style={{
                      objectFit: 'contain',
                      height: 'auto',
                      width: '100%',
                      maxWidth: '100px',
                      maxHeight: '120px',
                      mixBlendMode: 'multiply',
                      userSelect: 'none',
                      padding: '8px'
                    }} width={120} height={120} src={brand.imageUrl ?? ''} />
                        </Image>
                      </Box>
                    </SafeLink>)}
                </Flex>
              </Flex>
            </Flex>
          </Box>)}
      </Flex>
      <Box textAlign="center" data-sentry-element="Box" data-sentry-source-file="BrandCategoriesSection.tsx">
        <SafeLink unstyled href="/all-brands/" width={{
        base: 'full',
        tablet: '332px'
      }} data-sentry-element="SafeLink" data-sentry-source-file="BrandCategoriesSection.tsx">
          <Button backgroundColor="transparent" border="1px solid" borderColor="primary.500" borderRadius="8px" color="primary.500" textStyle="paragraph.small" fontWeight="regular" height="48px" padding={4} width={{
          base: 'full',
          tablet: '332px'
        }} _hover={{
          backgroundColor: 'primary.50'
        }} _active={{
          backgroundColor: 'primary.500',
          color: 'generic.0'
        }} data-sentry-element="Button" data-sentry-source-file="BrandCategoriesSection.tsx">
            View all
          </Button>
        </SafeLink>
      </Box>
    </SectionContainer>;
};
export default BrandCategoriesSection;